var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08606 2.01181H14.7377C14.9419 2.01181 15.1373 2.09509 15.2787 2.24241L20.3437 7.51841C20.4778 7.65808 20.5527 7.84419 20.5527 8.03781V17.2012C20.5691 19.7005 18.6012 21.7628 16.1041 21.8642C16.094 21.8646 16.0838 21.8648 16.0737 21.8648H8.09471C8.06992 21.8654 8.04821 21.8653 8.03254 21.8652C8.00868 21.865 8.00458 21.8648 7.99268 21.8648L7.97601 21.8646C5.45172 21.8085 3.45035 19.719 3.50068 17.196V6.49081L3.50089 6.47314C3.55951 3.98601 5.59859 2.00304 8.08606 2.01181ZM5.00068 6.50012V17.2038L5.00051 17.2201C4.96355 18.9176 6.3078 20.3244 8.00427 20.3649L8.02343 20.365L8.04483 20.3652L8.057 20.3652C8.05962 20.3652 8.06062 20.3652 8.0605 20.3652C8.06856 20.3649 8.07662 20.3648 8.08468 20.3648H16.0577C17.7408 20.2889 19.0648 18.8958 19.0527 17.2092L19.0527 17.2038L19.0527 8.33954L14.418 3.51181H8.0818C6.41275 3.50539 5.04442 4.83366 5.00068 6.50012Z",
    fill: "#8DC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4751 2C14.8893 2 15.2251 2.33579 15.2251 2.75V5.659C15.2251 6.66521 16.038 7.48066 17.0443 7.484H19.7981C20.2123 7.484 20.5481 7.81979 20.5481 8.234C20.5481 8.64821 20.2123 8.984 19.7981 8.984H17.0431L17.041 8.984C15.2077 8.97883 13.7251 7.49248 13.7251 5.659V2.75C13.7251 2.33579 14.0609 2 14.4751 2Z",
    fill: "#8DC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13794 15.3585C8.13794 14.9443 8.47373 14.6085 8.88794 14.6085H14.2879C14.7022 14.6085 15.0379 14.9443 15.0379 15.3585C15.0379 15.7727 14.7022 16.1085 14.2879 16.1085H8.88794C8.47373 16.1085 8.13794 15.7727 8.13794 15.3585Z",
    fill: "#8DC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13721 11.606C8.13721 11.1918 8.47299 10.856 8.88721 10.856H12.2432C12.6574 10.856 12.9932 11.1918 12.9932 11.606C12.9932 12.0202 12.6574 12.356 12.2432 12.356H8.88721C8.47299 12.356 8.13721 12.0202 8.13721 11.606Z",
    fill: "#8DC63F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.0fc5f8f3c7d971ca139a097c99b9d35e.svg";
export { ForwardRef as ReactComponent };